import { render, staticRenderFns } from "./WinOverlay.vue?vue&type=template&id=e74beaac&scoped=true&"
import script from "./WinOverlay.vue?vue&type=script&lang=js&"
export * from "./WinOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e74beaac",
  null
  
)

export default component.exports